import React from "react";
import { Button, InputAdornment } from "@sscs/ui";
import { PlaylistAddIcon as PlaylistAdd, SearchIcon } from "@sscs/ui/icons";
import styles from "./selectCreateAutocomplete.module.scss";

type CustomEndAdornmentProps = {
  shouldShowCreateNew: boolean;
  onCreateNewClick: () => void;
  subject: string;
};

const CustomEndAdornment = ({
  shouldShowCreateNew,
  onCreateNewClick,
  subject,
}: CustomEndAdornmentProps): React.JSX.Element => {
  if (shouldShowCreateNew) {
    return (
      <InputAdornment position="end" className={styles.adornment}>
        <Button
          variant="text"
          color="secondary"
          size="small"
          onClick={onCreateNewClick}
        >
          <PlaylistAdd />
          Create {subject}
        </Button>
      </InputAdornment>
    );
  } else {
    return (
      <InputAdornment position="end" className={styles.adornment}>
        <SearchIcon />
      </InputAdornment>
    );
  }
};

export default CustomEndAdornment;
